<template src="./Index.html">
</template>

<script>
import { showAlert } from "@/utils/helpers";
import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'

export default {
        model: {
            prop: "employee",
        },
        props: ["employee"],
  created() {

      this.HubConnect();
  },
  computed: {
    types() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.HealthDiseaseTypes
      );
    },
    uploadTypes(){
      return [
        {value : 1 , label : "عبر المسح الضوئي"},
       {value:2 , label :"تحميل المرفق من الجهاز"}
     ]
    }
  },
  data() {
    return {
      connection:"",
      index: null,
      actionFlag: false,
      healthList: [],
      headers: [
        {
          text: "نوع البيانات الصحية",
          value: "type",
          sortable: false,
          align: "start",
        },
        {
          text: "الاسم / الوصف",
          value: "description",
          sortable: false,
          align: "start",
        },

        {
          text: "الإجراءات",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      employeeObj: { employeeHealthDiseases: [] },
      employeeHealth: {
        healthDiseaseId: 0,
        attachmentFile: null,
        fileName: null,
        byScanner: null,
      },
    };
  },
  mounted: function() {

    },
  methods: {
    ChangeUploadTypes(){
      this.employeeHealth.attachmentFile= null;
      this.employeeHealth.fileName= null;
    },
    addInfo() {
      // return false;
      if (
        this.employeeHealth.attachmentFile != null && this.employeeHealth.byScanner == 2 &&
        this.employeeHealth.attachmentFile.type != "application/pdf" &&
        this.employeeHealth.attachmentFile.type != "image/jpeg" &&
        this.employeeHealth.attachmentFile.type != "image/jpg" &&
        this.employeeHealth.attachmentFile.type != "image/png"
      ) {
        showAlert("نوع المستند غير مدعوم يمكن رفع مستند pdf و صور فقط");
        return false;
      }

      let typeIndex = this.types.findIndex(
        (x) => x.value == this.employeeHealth.typeId
      );
        this.employeeObj.employeeHealthDiseases.push({
        healthDiseaseId: this.employeeHealth.healthDiseaseId,
        typeId: this.employeeHealth.typeId,
        type: this.types[typeIndex].label,
        description: this.employeeHealth.description,
        attachmentFile: this.employeeHealth.attachmentFile,
        fileName: this.employeeHealth.fileName,
        byScanner: this.employeeHealth.byScanner,
      });
      // console.log(this.employee.employeeHealthDiseases)
      (this.employeeHealth = {
        healthDiseaseId: 0,
        attachmentFile: null,
        fileName: null,
        byScanner: null,
      }),
        this.$refs.info.reset();

    },
    getInfoToEdit(index) {
      this.index = index;
        this.employeeHealth = this.employeeObj.employeeHealthDiseases[index];
      this.actionFlag = true;
    },
    removeInfo(index) {
        this.employeeObj.employeeHealthDiseases.splice(index, 1);
    },
    editInfo() {
        this.employeeObj.employeeHealthDiseases.splice(
        this.index,
        1,
        this.employeeHealth
      );
      (this.employeeHealth = {
        healthDiseaseId: 0,
        attachmentFile: null,
        fileName: null,
        byScanner: null,
      }),
        this.$refs.info.reset();
      this.actionFlag = false;

    },
      confirm() {
          if (this.employeeObj.employeeHealthDiseases.length == 0) {
              showAlert("الرجاء ادخال بيانات صحية واحدة على الاقل");
              return false;
          }
      let payload = {
          employeeId: this.employee.employeeId,
          items: this.employeeObj.employeeHealthDiseases,
      };
      this.$store
          .dispatch("employeeHealth/edit", { id: this.employee.healthInfoId, payload: payload })
        .then(() => {
            this.$emit("nextStep");
        })
        .catch(() => {});
    },
    allowedDates(val) {
      const today = new Date();
      today.setFullYear(today.getFullYear() - 15);
      const date = new Date(val);
      return date < today;
    },
    back() {
      this.connection.stop();

      this.$emit("back");
    },
    download(item) {
      window.open(
        `/api/employeeHealth/${item.healthDiseaseId}/attachment`,
        "_blank"
      );
      },
      cancel() {
          this.$emit("nextStep");
      },
    // -------------- scan -------------------------- //
    scann() {
      var type = this.$attachmentTypes.HealthFile;
      console.log(type);
      var p = "DisableScanner331://" + 1 + "-" + type ;
      console.log(p);
      window.location.href = p;
      this.connection.on("ReceiveMessage", (fileName) => {
        console.log(fileName);
        this.employeeHealth.fileName = fileName;
      });
    },
    HubConnect(){
      this.connection = new HubConnectionBuilder()
        .withUrl("/ScanHub")
        .configureLogging(LogLevel.Information)
        .build();
      this.connection.start().catch(function(err) {
        return console.error(err.toSting());
      });
    },
  },
};
</script>